import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import CampaignsList from './CampaignsList'
import YearlyOverview from './YearlyOverview'

export type AgencyCampaign = {
  date: string
  product_name: string
  product_code: string
  client_campaign_id: number
  client_campaign_display_name: string
  booked_impressions: number
  impressions: number
  clicks: number
  views: number
  ctr: number
  vtr: number
  delivery: number
  dealership_id: number
  dealership_name: string
  start_date: string
  end_date: string
  gross_revenue: number
  date_rsv: number
  rsv: number
  sales: number
}

const AgencyCampaigns = (): JSX.Element => {
  return (
    <Routes>
      <Route path="*">
        <Route path="list" element={<CampaignsList />} />
        <Route path="yearly" element={<YearlyOverview />} />
        <Route path="*" element={<Navigate to={'list'} />} />
      </Route>
    </Routes>
  )
}

export default AgencyCampaigns
